import { h, Fragment, ComponentChildren } from "preact"; /** @jsx h */


export type IAuthoredProps = {
    authorLinkTo?: string; // "./author.html"
    authorName?: string;
    publishedAt?: string; //Dec 12
    readingTime?: string;
    authorImage?: string;
};

export const Authored = (props: IAuthoredProps) => {
    
    if (!props.authorName) {
        return null;
    }

    return (
        props.authorImage
        ? <div class="d-flex align-items-center">
            <img class="rounded-circle" src={props.authorImage} width="70"></img>
            <small class="ml-2">
                {/*<a href={props.authorLinkTo}>
                    { props.authorName }
                </a>*/}
                { props.authorName }
                <span class="text-muted d-block">
                    {props.publishedAt ? `${props.publishedAt}` : ""}
                    {props.publishedAt && props.readingTime ? <Fragment> &middot; </Fragment> : ""}
                    {props.readingTime ? `${props.readingTime} min read` : ""}
                </span>
            </small>
        </div>
        : <div>
            <small className="text-muted">
                {/*<a href={props.authorLinkTo}>
                    { props.authorName }
                </a>*/}
                { props.authorName }
                <Fragment> &middot; </Fragment>
                {props.publishedAt ? `${props.publishedAt}` : ""}
                {props.publishedAt && props.readingTime ? <Fragment> &middot; </Fragment> : ""}
                {props.readingTime ? `${props.readingTime} min read` : ""}
            </small>
        </div>
    );
}
  
